import React from "react";
import './politicas.css';
import { getbyID } from "../../modules/datafunction";
import { politicadeprivacidad } from "../../modules/data";
import {container} from "../../modules/primecompo";

const getitem0=()=>{   
    const pdata=getbyID({item:0},politicadeprivacidad)
    const content0=<h1>{pdata['title']} </h1>
        
    return(container(content0,"row0"))}

const getitem1=()=>{
    const pdata=getbyID({item:1},politicadeprivacidad)
    const content0 =
        <div>
            {pdata['span'].map((item, index) => (
                <div key={index}>
                    <span className="span">{item}</span>
                    {pdata['p'][index].map((item2, index2) => (
                        <p key={index2}>{item2}</p>
                    ))}
                </div>
            ))
            }
        </div>;
   
        
    return(container(content0,"row0"))}

const Politica=()=>{


    return(
        <div className="politicas"> 
            {getitem0()}
            {getitem1()}
        </div>


    )
}

export default Politica;
    